const RefundRequests = () => {
  return <></>
}

export default RefundRequests
